// extracted by mini-css-extract-plugin
export var divider = "_q7-0";
export var systemMessage = "_q7-1";